import { lazy } from "react";

const Login = lazy(() => import("./pages/authentication/Login"));
const Register = lazy(() => import("./pages/authentication/Register"));
const EmailVerification = lazy(() =>
  import("./pages/authentication/EmailVerification")
);
const ResetPassword = lazy(() =>
  import("./pages/authentication/ResetPassword")
);
const Dashboard = lazy(() => import("./pages/Dashboard"));
const BusinessManagement = lazy(() => import("./pages/BusinessManagement"));
const Transactions = lazy(() => import("./pages/Transactions"));
const Profile = lazy(() => import("./pages/Profile"));
const Products = lazy(() => import("./pages/Products"));
const ViewBusiness = lazy(() => import("./pages/viewBusiness/index"));
const ViewOrder = lazy(() => import("./pages/ViewOrder"));
const Reports = lazy(() => import("./pages/reports/index"));
const ViewProduct = lazy(() => import("./pages/ViewProduct"));
const OrderDetails = lazy(() => import("./pages/OrderDetails"));
const UserManagement = lazy(() => import("./pages/UserManagement"));
const ViewUser = lazy(() => import("./pages/ViewUser"));
const AddUser = lazy(() => import("./pages/AddUser"));
const EditUser = lazy(() => import("./pages/EditUser"));
const Events = lazy(() => import("./pages/Events"));
const ViewEvent = lazy(() => import("./pages/ViewEvent"));
const EditEvent = lazy(() => import("./pages/EditEvent"));
const Wallet = lazy(() => import("./pages/Wallet"));
const RolesPermissions = lazy(() => import("./pages/RolesPermissions"));
const AuditLogs = lazy(() => import("./pages/AuditLogs"));
const Refunds = lazy(() => import("./pages/Refunds"));
// const Delivery = lazy(() => import("./pages/Delivery"))
// const ViewDelivery = lazy(() => import("./pages/ViewDelivery"))
const KnowYourCustomer = lazy(() => import("./pages/knowYourCustomer/index"));
const CreateBusiness = lazy(() => import("./pages/CreateBusiness"));
const NotificationSettings = lazy(() => import("./pages/NotificationSettings"));
const PaymentIntegration = lazy(() => import("./pages/PaymentIntegration"));
const IntegrationGuide = lazy(() => import("./pages/IntegrationGuide"));

const routes = [
  {
    title: "Login",
    path: "/",
    isProtected: false,
    element: <Login />,
  },
  {
    title: "Register",
    path: "/register",
    isProtected: false,
    element: <Register />,
  },
  {
    title: "Email Verification",
    path: "/verify-email",
    isProtected: false,
    element: <EmailVerification />,
  },
  {
    title: "Reset Password",
    path: "/reset-password",
    isProtected: false,
    element: <ResetPassword />,
  },
  {
    title: "Dashboard",
    path: "/dashboard",
    isProtected: true,
    element: <Dashboard />,
  },
  {
    title: "Business Management",
    path: "/business-management",
    isProtected: true,
    element: <BusinessManagement />,
  },
  {
    title: "Orders & Transactions",
    path: "/orders",
    isProtected: true,
    element: <Transactions />,
  },
  {
    title: "User Profile",
    path: "/profile",
    isProtected: true,
    element: <Profile />,
  },
  {
    title: "Products",
    path: "/products",
    isProtected: true,
    element: <Products />,
  },
  {
    title: "View Business",
    path: "/business-management/view-business/:id",
    isProtected: true,
    element: <ViewBusiness />,
  },
  {
    title: "View Refund",
    path: "/refunds/refund/:id",
    isProtected: true,
    element: <ViewOrder />,
  },
  {
    title: "View Product",
    path: "/products/product/:id",
    isProtected: true,
    element: <ViewProduct />,
  },
  {
    title: "Order Details",
    path: "/orders/order/:id",
    isProtected: true,
    element: <OrderDetails />,
  },
  {
    title: "Reports & Analytics",
    path: "/reports",
    isProtected: true,
    element: <Reports />,
  },
  {
    title: "User Management",
    path: "/system/user-management",
    isProtected: true,
    element: <UserManagement />,
  },
  {
    title: "User Management",
    path: "/system/user-management/user/:id",
    isProtected: true,
    element: <ViewUser />,
  },
  {
    title: "User Management",
    path: "/system/user-management/add-user",
    isProtected: true,
    element: <AddUser />,
  },
  {
    title: "User Management",
    path: "/system/user-management/edit-user/:id",
    isProtected: true,
    element: <EditUser />,
  },
  {
    title: "Events",
    path: "/events",
    isProtected: true,
    element: <Events />,
  },
  {
    title: "Events",
    path: "/events/event/:id",
    isProtected: true,
    element: <ViewEvent />,
  },
  {
    title: "Edit Event",
    path: "/events/edit-event/:id",
    isProtected: true,
    element: <EditEvent />,
  },
  {
    title: "Wallet",
    path: "/wallet",
    isProtected: true,
    element: <Wallet />,
  },
  {
    title: "Permissions",
    path: "/system/permissions",
    isProtected: true,
    element: <RolesPermissions />,
  },
  {
    title: "Audit Logs",
    path: "/system/auditlogs",
    isProtected: true,
    element: <AuditLogs />,
  },
  {
    title: "Refunds",
    path: "/refunds",
    isProtected: true,
    element: <Refunds />,
  },

  // {
  //   title: "Delivery",
  //   path: "/delivery",
  //   isProtected: true,
  //   element: <Delivery />,
  // },
  // {
  //   title: "Delivery",
  //   path: "/delivery/view-delivery/:id",
  //   isProtected: true,
  //   element: <ViewDelivery />,
  // },

  {
    title: "Compliance/KYC",
    path: "/kyc",
    isProtected: true,
    element: <KnowYourCustomer />,
  },
  {
    title: "Create a Business",
    path: "/dashboard/create-business",
    isProtected: true,
    element: <CreateBusiness />,
  },
  {
    title: "Create a Business",
    path: "/notification-settings",
    isProtected: true,
    element: <NotificationSettings />,
  },
  {
    title: "Payment Integration",
    path: "/payment-integration",
    isProtected: true,
    element: <PaymentIntegration />,
  },
  {
    title: "Integration Guide",
    path: "/integration-guide",
    isProtected: true,
    element: <IntegrationGuide />,
  },
];

export default routes;
